module.exports = __webpack_public_path__ + "assets/images/avatar_side_shadow.1af95630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/avatar_side_shadow.png
// module id = 683
// module chunks = 1